const notAuthenticate = ({ store, redirect }) => {
  // If the user is authenticated redirect to home page
  if (store.state.auth.isAuthenticated) {
    return redirect('/space');
  }
};

export default notAuthenticate;
